<template>
  <div>
    <!-- filter -->
    <targeting-filter placeholder="请输入定向名称" @on-change="filterData" @on-search="searchFilterData" />
    <div class="control-btns-row">
      <div class="btns">
        <Button @click="$router.push({ name: 'tartencentadd' })">新建腾讯定向包</Button>
        <Button @click="$router.push({ name: 'tarkuaishouadd' })">新建磁力引擎定向包</Button>
        <!-- <Button @click="$router.push({ name: 'tarUCadd' })">新建超级汇川定向包</Button> -->
        <Button @click="$router.push({ name: 'tarbaiduadd' })">新建百度定向包</Button>
        <Button @click="$router.push({ name: 'ToutiaoTargetingAdd' })">新建头条定向包</Button>
      </div>

      <Button @click="modalColumn = true">自定义列</Button>
    </div>
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <targeting-table
          ref="targetingTable"
          :loading="loading"
          :data="tableList"
          :columns="tableCols"
          :height="tableHeight"
          @on-loadAudiues="loadAudiues"
          @on-del="deleteRowTargeting"
          @on-refresh="getData"
          @on-sort="sortTable"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :subTitle="['基础数据', '报表数据']" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, timeout } from '@/common/js/utils'
import { deCompile, teCompile } from '@/common/js/decompile'
import { ksCompile } from '@/common/js/kscompile'
import { bdCompile } from '@/common/js/bdcompile'

import { getTargetingData, deleteTargeting, queryManageIdByMedia } from '@/api/manage.model'
import { getCustomAudience, actionId2Word } from '@/api/toutiao.model'
import { getMobileMediaType, getActionInterestCategory, getDevice } from '@/api/tencent.model'
import { getTargetingTags, getBehaviorAndInterest } from '@/api/kuaishou.model'

import columns from '../data/targeting_column'
import TargetingFilter from './components/mediatargeting-filter'
import TargetingTable from './components/mediatargeting-table.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import cityData from '@/data/toutiao/city_province'
import tagsData from '@/data/toutiao/ad_tag'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'

import androidVersion from '@/data/tencent/android_version'
import iosVersion from '@/data/tencent/ios_version'
import gdtCityData from '@/data/tencent/city_province'

import bdCityData from '@/data/baidu/city_province'
import bdGategoryData from '@/data/baidu/app_categroy'
import bdInterestData from '@/data/baidu/new_interests'

import ksCityData from '@/data/kuaishou/city_province'

export default {
  name: 'targeting',
  mixins: [mixin],
  components: { CustomColumn, TargetingFilter, TargetingTable },
  computed: {
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    },
    // 存local用户自定义列
    custom() {
      return 'target'
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.targetingTable && this.$refs.targetingTable.doLayout()
        })
      },
      deep: true
    }
  },
  // 如果是从新增定向页面返回，刷新数据
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (['tarbaiduadd', 'tarkuaishouadd', 'tartencentadd', 'ToutiaoTargetingAdd'].includes(from.name)) {
        vm.getData()
      }
    })
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getTargetingData(params).then((data) => {
        this.loading = false
        if (!data) return
        const { list, page_info } = data
        if (isArray(list) && page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
          this.tableList = list.map((ret) => {
            const isExsistTargeting = !JSON.stringify(ret.targetingParamJson) === '{}' || !ret.targetingParamJson
            // ret.comping = ret.createOpId === 1
            // ret.targets = ret.comping ? [] : this.deCompile(ret.targetingParamJson)
            if (isExsistTargeting) {
              if (ret.mediaId === 16) ret.targets = teCompile(ret.targetingParamJson, this.gdtOrignData)
              else if (ret.mediaId === 32) ret.targets = ksCompile(ret.targetingParamJson, this.ksOrignData)
              else if (ret.mediaId === 45) ret.targets = bdCompile(ret.targetingParamJson, this.bdOrignData)
              else if (ret.mediaId === 10) ret.targets = deCompile(ret.targetingParamJson, this.orignData)
            }
            return ret
          })
        }
      })
    },
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    deleteRowTargeting({ targetingId }) {
      this.loading = true
      deleteTargeting({ targetingId }).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('定向删除成功！')
          timeout(600).then(() => {
            this.getData()
          })
        }
      })
    },
    setLocalPage(size) {
      setLocal('Targeting_PAGESIZE', size)
    },
    loadAudiues([row, index]) {
      const proload_all = []
      const { createOpId, account = 3232, accountIds } = row
      const {
        interest_categories,
        interest_words,
        action_days,
        action_scene,
        action_categories,
        action_words,
        retargeting_tags_exclude,
        retargeting_tags_include
      } = row.targetingParamJson
      const iCate = isArray(interest_categories) && interest_categories.length
      const iWord = isArray(interest_words) && interest_words.length
      const aCate = isArray(action_categories) && action_categories.length
      const aWord = isArray(action_words) && action_words.length
      const include = isArray(retargeting_tags_include) && retargeting_tags_include.length
      const exclude = isArray(retargeting_tags_exclude) && retargeting_tags_exclude.length
      if (createOpId !== 1) return
      if (isArray(action_scene) && !action_scene.length) action_scene.push(...['E-COMMERCE', 'NEWS', 'APP'])
      if (iCate || iWord || aCate || aWord) {
        // 兴趣定向
        if (aCate) {
          proload_all.push(
            actionId2Word({
              ad_account_id: account,
              targeting_type: 'ACTION',
              tag_type: 'CATEGORY',
              ids: action_categories.join(','),
              action_scene: action_scene.join(','),
              action_days
            })
          )
        }
        if (aWord) {
          proload_all.push(
            actionId2Word({
              ad_account_id: account,
              targeting_type: 'ACTION',
              tag_type: 'KEYWORD',
              ids: action_words.join(','),
              action_scene: action_scene.join(','),
              action_days
            })
          )
        }
        if (iCate) {
          proload_all.push(
            actionId2Word({ ad_account_id: account, targeting_type: 'INTEREST', tag_type: 'CATEGORY', ids: interest_categories.join(',') })
          )
        }
        if (iWord) {
          proload_all.push(
            actionId2Word({ ad_account_id: account, targeting_type: 'INTEREST', tag_type: 'KEYWORD', ids: interest_words.join(',') })
          )
        }
      }
      if (include || exclude) {
        // 人群包定向
        proload_all.push(getCustomAudience({ account: accountIds }))
      }
      // 封装一起请求
      Promise.all(proload_all).then((data) => {
        const actionCategories = aCate && data.shift()
        const actionWords = aWord && data.shift()
        const interestCategories = iCate && data.shift()
        const interestWords = iWord && data.shift()
        const audiences = (include || exclude) && data.shift()
        const action_tags = []
        const word_tags = []
        const includes = []
        const excludes = []
        if (actionCategories && isArray(actionCategories.categories)) {
          const actions = actionCategories.categories.map((ret) => {
            ret.type = 'CATEGORY'
            return ret
          })
          action_tags.push(...actions)
        }
        if (actionWords && isArray(actionWords.keywords)) {
          const actions = actionWords.keywords.map((ret) => {
            ret.type = 'KEYWORD'
            return ret
          })
          action_tags.push(...actions)
        }
        if (interestCategories && isArray(interestCategories.categories)) {
          const words = interestCategories.categories.map((ret) => {
            ret.type = 'CATEGORY'
            return ret
          })
          word_tags.push(...words)
        }
        if (interestWords && isArray(interestWords.keywords)) {
          const words = interestWords.keywords.map((ret) => {
            ret.type = 'KEYWORD'
            return ret
          })
          word_tags.push(...words)
        }
        if (audiences && audiences.success && isArray(audiences.models.retData)) {
          const retIncludes = audiences.models.retData.map((r) => {
            return {
              id: r.custom_audience_id,
              name: r.name,
              source: r.source
            }
          })
          retargeting_tags_include.forEach((ret) => {
            const item = retIncludes.filter((met) => met.id === ret).pop()
            item && includes.push(item)
          })
          retargeting_tags_exclude.forEach((ret) => {
            const item = retIncludes.filter((met) => met.id === ret).pop()
            item && excludes.push(item)
          })
        }
        this.$set(
          this.tableList[index],
          'targets',
          deCompile(Object.assign({}, row.targetingParamJson, { action_tags, word_tags, includes, excludes }), this.orignData)
        )
        this.$set(this.tableList[index], 'comping', false)
      })
    },
    preloadData() {
      const convertData = (children) => {
        if (!children) return []
        return children.map((ret) => {
          return {
            id: Number(ret.id),
            key: Number(ret.id),
            value: ret.name,
            children: ret.children && ret.children.length > 0 ? convertData(ret.children) : []
          }
        })
      }
      queryManageIdByMedia()
        .then((data) => {
          if (data && isArray(data)) {
            const tencentId = data.filter((ret) => ret.mediaId === 16).pop().manageId
            const kuaishouId = data.filter((ret) => ret.mediaId === 32).pop().manageId
            const tagParams = {
              ad_account_id: kuaishouId,
              type: 'BUSINESS_INTEREST'
            }
            Promise.all([
              getMobileMediaType({ ad_account_id: tencentId }),
              getActionInterestCategory({ ad_account_id: tencentId, type: 'INTENTION' }),
              getDevice({ ad_account_id: tencentId }),
              getTargetingTags(tagParams),
              getTargetingTags(Object.assign({}, tagParams, { type: 'FANS_STAR' })),
              getTargetingTags(Object.assign({}, tagParams, { type: 'INTEREST_VIDEO' })),
              getTargetingTags(Object.assign({}, tagParams, { type: 'APP_INTEREST' })),
              getBehaviorAndInterest({ ad_account_id: kuaishouId })
            ]).then((data) => {
              const [
                mediaTypeData,
                intentData,
                brandData,
                businessInterest,
                starInterest,
                videoInterest,
                appInterest,
                behaviorAndInterest
              ] = data
              if (mediaTypeData && isArray(mediaTypeData)) {
                this.gdtOrignData.mobileMediaTypeData = mediaTypeData.map((ret) => {
                  return {
                    id: Number(ret.id),
                    key: Number(ret.id),
                    value: ret.value,
                    children: convertData(ret.children) // 递归修改数据结构
                  }
                })
              }
              if (intentData && isArray(intentData)) {
                this.gdtOrignData.intentData = intentData.map((ret) => {
                  return {
                    id: Number(ret.id),
                    key: Number(ret.id),
                    value: ret.value,
                    children: convertData(ret.children) // 递归修改数据结构
                  }
                })
              }
              if (brandData && isArray(brandData)) {
                this.gdtOrignData.brandData = brandData.map((ret) => {
                  return {
                    id: Number(ret.id),
                    key: Number(ret.id),
                    value: ret.value,
                    children: convertData(ret.children) // 递归修改数据结构
                  }
                })
              }

              // 快手
              this.ksConvertOriginData(businessInterest, starInterest, videoInterest, appInterest, behaviorAndInterest)
            })
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },
    ksConvertOriginData(businessInterest, starInterest, videoInterest, appInterest, behaviorAndInterest) {
      const format = (ret) => {
        return {
          id: ret.id,
          value: ret.name
        }
      }
      isArray(businessInterest) && (this.ksOrignData.businessData = businessInterest.map(format))
      isArray(starInterest) && (this.ksOrignData.starData = starInterest.map(format))
      isArray(videoInterest) && (this.ksOrignData.videoData = videoInterest.map(format))
      isArray(appInterest) && (this.ksOrignData.appData = appInterest.map(format))
      if (behaviorAndInterest) {
        const mapCategroy = (ret) => {
          const cate = {
            id: ret.id,
            value: ret.name
          }
          if (ret.children) {
            return Object.assign({}, cate, {
              children: ret.children.map(mapCategroy)
            })
          } else {
            return cate
          }
        }
        const { behavior, interest } = behaviorAndInterest
        this.ksOrignData.behaviorAndInterest = { behavior: behavior.map(mapCategroy), interest: interest.map(mapCategroy) }
      }
    }
  },
  data() {
    return {
      tableHeight: 330,
      modalColumn: false, // 自定义列
      columns: [], // 表格字段
      tableList: [], // 表格数据
      accountId: 5165, // 获取通用枚举数据时使用
      ks_account: 3602,
      orignData: {
        cityData: cityData,
        brandData: brandData,
        tagsData: tagsData,
        gategoryData: gategoryData,
        articleData: articleData,
        autotendData: autotendData
      },
      gdtOrignData: {
        cityData: gdtCityData,
        brandData: [], // 手机品牌
        mobileMediaTypeData: [], // 移动媒体类型数据
        intentData: [], // 意向
        versionData: [...androidVersion, ...iosVersion]
      },
      ksOrignData: {
        cityData: ksCityData,
        businessData: [],
        starData: [],
        videoData: [],
        appData: [],
        audienceData: [],
        behaviorAndInterest: {}
      },
      bdOrignData: {
        cityData: bdCityData,
        gategoryData: bdGategoryData,
        interestData: bdInterestData
      }
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('Targeting_PAGESIZE')) || 20
    this.sort = 'create_time'
    this.order = 'desc'
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret)
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
    this.preloadData() // 获取腾讯广告定向参数初始化数据
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-targeting {
}

.c-table-page {
  padding: 5px 0;
  text-align: right;
}

.control-btns-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;

  .btns {
    button {
      border-color: $primary-color;
      color: $primary-color;
      margin-right: 3px;
    }
  }
}
</style>
